import { render, staticRenderFns } from "./CalendarDetails.vue?vue&type=template&id=8e4695dc&scoped=true&"
import script from "./CalendarDetails.vue?vue&type=script&lang=js&"
export * from "./CalendarDetails.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDetails.vue?vue&type=style&index=0&id=8e4695dc&lang=scss&scoped=true&"
import style1 from "./CalendarDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4695dc",
  null
  
)

export default component.exports